export default __webpack_public_path__ + "static/media/SAS0090.34I-41817_-25105_0.2d1dfc7c.jpg";